module.exports = __webpack_public_path__ + "img/prevent-img-two.78574722.jpg";